import React, { Component } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import ExperianForm from "./ExperianForm";
import i18n from "../../i18n";
import * as rk from "../../localization/resourceKeys";
import { verifyExperianDetails } from "../../redux/ExperianForm/experianAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { clearErrors } from "../../redux/Errors/actions";
import BottomLine from "../Footer/BottomLine";
import {
  verifyProtectionServicesExperianDetails,
  verifyProtectionServicesExperianDetailsCheckMyRequests,
} from "../../redux/ProtectionServicesExperianForm/protectionServicesExperianAction";
import { submitPrivacyRequest } from "../../redux/MailingAddressSelector/actions";
import PropTypes from "prop-types";

class Container extends Component {
  constructor(props) {
    super(props);
    if (!props?.getExperianReducer?.data?.kba?.questionSet) {
      window.location.replace("/");
    }
  }

  componentDidMount() {
    this.props.clearErrors();
  }

  getQuestions = () => {
    try {
      let questionsObj = this.props.getExperianReducer.data.kba.questionSet;
      let experianFormOptions = [];
      for (const key in questionsObj) {
        experianFormOptions.push({
          question: questionsObj[key].questionText,
          options: this.getOptions(
            questionsObj[key].questionSelect.questionChoice
          ),
          id: "option" + key,
        });
      }
      return experianFormOptions;
    } catch {
      window.location.href = "/";
    }
  };

  getOptions = (question) => {
    let optionsObj = [];

    for (const key in question) {
      optionsObj.push({
        value: question[key],
        index: key,
        isChecked: "false",
        customName: question[key],
      });
    }

    return optionsObj;
  };

  validate() {
    //get an arrary of validators based on the Experian JSON
    const validators = this.getQuestions().map((item) => {
      return { [item.id]: Yup.string().required("Field is required.") };
    });

    //reduce validators array to object set
    const validationObject = validators.reduce((val, field) => {
      let key = Object.keys(field)[0];
      val[key] = field[key];
      return val;
    }, {});

    //return all objects as a Yup shaped object
    return Yup.object().shape(validationObject);
  }

  initVals() {
    let returnValue = {};

    // loop the Experian json to get the item ids and then
    // add to object with item id as undefined
    this.getQuestions().forEach((item) => {
      returnValue = {
        ...returnValue,
        [item.id]: undefined,
      };
    });

    return returnValue;
  }

  routeOnSubmit = () => {
    const { t } = this.props;
    if (
      this.props.selectedRequest === i18n.t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA)
    ) {
      this.props.history.push("/formComplete", {
        isDataCorrectionFormComplete: true,
      });
    }
    if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO)) {
      if (
        this.props.info.reportType === t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES)
      ) {
        this.props.history.push("/formComplete", { isTier2FormComplete: true });
      }
      if (this.props.info.reportType === t(rk.INFO_FORM.REPORT_CATEGORY)) {
        this.props.history.push("/formComplete", { isTier1FormComplete: true });
      }
    }
  };

  render() {
    const submitPrivacyRequestPayload = this.props.location.state
      ? this.props.location.state.submitPrivacyRequestPayload
      : "";
    const isProtectionServices =
      this.props?.stateSelector?.brandAffiliation ===
      i18n.t(rk.BRANDS_OPTION_VWD_APP_DER);
    const selectedFlow =
      this.props?.requestForm?.step?.selectedFlow ||
      this.props?.stateSelector?.selectedFlow;
    return (
      <Formik
        initialValues={this.initVals()}
        validationSchema={this.validate()}
        onSubmit={async (values, { setSubmitting }) => {
          await this.props.clearErrors();
          const verifyExperianPayload = {
            lastName:
              this.props.info.lastName ||
              this.props.experianReducer.payload.lastName,
            outWalletQuestionsRequest:
              this.props.getExperianReducer.data.kba.general.numberOfQuestions,
            sessionId: this.props.getExperianReducer.data.kba.general.sessionID,
            outWalletAnswer1: values.option0.toString(),
            outWalletAnswer2: values.option1.toString(),
            outWalletAnswer3: values.option2.toString(),
            outWalletAnswer4: values.option3.toString(),
            outWalletAnswer5: values.option4.toString(),
          };
          if (isProtectionServices) {
            // Check my requests
            if (selectedFlow === "check") {
              const payload = this.props.getExperianReducer.payload;
              this.props.verifyProtectionServicesExperianDetailsCheckMyRequests(
                verifyExperianPayload,
                this.props.history,
                payload
              );
            } else {
              submitPrivacyRequestPayload.requester.last4Ssn =
                this.props.info.ssn.length === 4
                  ? this.props.info.ssn
                  : this.props.info.ssn.length === 9
                  ? this.props.info.ssn.slice(5, 9)
                  : "";
              submitPrivacyRequestPayload.requester.fullSsn =
                this.props.info.ssn.length === 9 ? this.props.info.ssn : "";
              this.props.verifyProtectionServicesExperianDetails(
                verifyExperianPayload,
                this.routeOnSubmit,
                this.props,
                submitPrivacyRequestPayload
              );
            }
          } else {
            this.props.verifyExperianDetails(
              verifyExperianPayload,
              this.props.history,
              submitPrivacyRequestPayload
            );
          }
          setSubmitting(false);
        }}
      >
        {(props) => {
          return (
            <>
              <ExperianForm
                networkError={this.props.networkError}
                questions={this.getQuestions()}
                {...props}
              />
              <div className="request-footer-wrapper">
                <div
                  id="request-footer-content"
                  className="request-footer-content-2"
                >
                  <BottomLine />
                </div>
              </div>
            </>
          );
        }}
      </Formik>
    );
  }
}

Container.propTypes = {
  verifyExperianReducer: PropTypes.shape({
    data: PropTypes.shape({
      experianTransactionId: PropTypes.string,
      isExperianVerified: PropTypes.bool,
    }),
  }),
  getExperianReducer: PropTypes.shape({
    payload: PropTypes.shape({
      lastName: PropTypes.string,
      ssn: PropTypes.string,
      reportType: PropTypes.string,
    }),
    data: PropTypes.shape({
      kba: PropTypes.shape({
        general: PropTypes.shape({
          numberOfQuestions: PropTypes.number,
          sessionID: PropTypes.string,
        }),
        questionSet: PropTypes.arrayOf(PropTypes.object),
      }),
    }),
  }),
  verifyProtectionServicesExperianReducer: PropTypes.object,
  info: PropTypes.shape({
    ssn: PropTypes.string,
    reportType: PropTypes.string,
    lastName: PropTypes.string,
  }),
  experianReducer: PropTypes.shape({
    payload: PropTypes.shape({
      lastName: PropTypes.string,
      ssn: PropTypes.string,
    }),
  }),
  stateSelector: PropTypes.object.isRequired,
  selectedRequest: PropTypes.string.isRequired,
  requestForm: PropTypes.object.isRequired,
  networkError: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      submitPrivacyRequestPayload: PropTypes.object,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  verifyExperianDetails: PropTypes.func.isRequired,
  verifyProtectionServicesExperianDetails: PropTypes.func.isRequired,
  verifyProtectionServicesExperianDetailsCheckMyRequests:
    PropTypes.func.isRequired,
  submitPrivacyRequest: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  info: state.info,
  stateSelector: state.stateSelector,
  selectedRequest: state.requestSelector.selectedRequest,
  requestForm: state.requestForm,
  getExperianReducer: state.getExperianReducer,
  verifyExperianReducer: state.verifyExperianReducer,
  networkError: state.networkError,
  experianReducer: state.getProtectionServicesExperianReducer,
});

const mapDispatchToProps = (dispatch) => ({
  verifyExperianDetails: (action, routeProps, submitPrivacyRequestPayload) =>
    dispatch(
      verifyExperianDetails(action, routeProps, submitPrivacyRequestPayload)
    ),
  verifyProtectionServicesExperianDetails: (
    action,
    routeProps,
    historyProps,
    submitPrivacyRequestPayload
  ) =>
    dispatch(
      verifyProtectionServicesExperianDetails(
        action,
        routeProps,
        historyProps,
        submitPrivacyRequestPayload
      )
    ),
  verifyProtectionServicesExperianDetailsCheckMyRequests: (
    action,
    routeProps,
    historyProps
  ) =>
    dispatch(
      verifyProtectionServicesExperianDetailsCheckMyRequests(
        action,
        routeProps,
        historyProps
      )
    ),
  submitPrivacyRequest: (action, routeProps, historyProps) =>
    dispatch(submitPrivacyRequest(action, routeProps, historyProps)),
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Container));
